import script from "./TabsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=5147e9c4&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5147e9c4"]])

export default __exports__